























import Vue from 'vue';
import { Type, AnyType } from 'expangine-runtime';
import { Registry } from '../runtime/Registry';


export default Vue.extend({
  props: {
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    data: {
      required: true,
    },
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    dataType(): Type {
      const described = this.registry.defs.describe(this.data);
      if (described) {
        described.removeDescribedRestrictions();
      }
      return described || AnyType.baseType;
    },
    rawString(): string {
      return JSON.stringify(this.dataType.toJson(this.data), undefined, 2);
    },
  },
});
